module.exports = __webpack_public_path__ + "static/img/02.b5f8941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news21/02.png
// module id = S6J4
// module chunks = 1